export const SPORTS = [
  { code: "baseball", label: "Baseball", enabled: true },
  { code: "football", label: "Football", enabled: true },
  { code: "basketball", label: "Basketball", enabled: true },
  { code: "hockey", label: "Hockey", enabled: false },
];

// Football -> NFL and Basketball -> NBA are experimental (see pages/Dashboard.jsx): bounded
// public-data model projections only, no market lines/predictions like the baseball leagues below.
export const LEAGUES_BY_SPORT = {
  baseball: ["MLB", "NPB", "LMB", "CPB", "LMP", "KBO"],
  football: ["NFL"],
  basketball: ["NBA"],
};
